export default function HealthCheck() {
  return (
    <>
      <h2>up!</h2>
    </>
  );
}
